export const stackedBarDataSanitizer = (barChartDetail: any, kpiLabel?: string) => {
  if (!barChartDetail) return null;

  // If it's already in StackedBarChart format (has segments), return as is
  if (Array.isArray(barChartDetail) && barChartDetail[0]?.segments) {
    return barChartDetail;
  }

  // Transform from barChartDetail format
  // API format: { bars: [{ barName: "PY 21", barComponent: [{ yValue: "2836.19", xValue: "total" }] }] }
  // StackedBarChart format: [{ label: "PY 21", segments: [{ label: "total", value: 2836.19 }] }]
  if (barChartDetail?.body?.bars && Array.isArray(barChartDetail.body.bars)) {
    return barChartDetail.body.bars.map((bar: any) => ({
      label: (bar.barName || bar.xValue)?.replace('($)', '').trim(),
      segments:
        bar.barComponent?.map((component: any) => {
          let label = component.xValue || component.label || bar.barName || 'total';

          // Used as fallback when segment label is "total"
          if (label === 'total' && kpiLabel) {
            label = kpiLabel;
          }

          return {
            label,
            value:
              typeof component.yValue === 'string'
                ? parseFloat(component.yValue)
                : component.yValue,
          };
        }) || [],
    }));
  }

  return null;
};
